<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="800px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { KeyValue } from '@/modules/hub/data/key-value/create'
	import { KeyValueService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return KeyValue
			},
			service()
			{
				return new KeyValueService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>